import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerLeftUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-corner-left-up"} maskId="square-filled-radius-0-stroke-1-IconArrowCornerLeftUp"><path fillRule="evenodd" clipRule="evenodd" d="M9.00008 2.79297L14.2072 8.00008L13.5001 8.70718L9.50008 4.70718V20.0001H20.0001V21.0001H8.50008V4.70718L4.50008 8.70718L3.79297 8.00008L9.00008 2.79297Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowCornerLeftUp;
